import { Chip, ChipProps } from '@mui/material';
import React from 'react';

const StatusChip = React.forwardRef<HTMLDivElement, ChipProps>((props, ref) => {
  return (
    <Chip
      {...props}
      ref={ref}
      sx={{
        height: '16.17px',
        fontSize: '11px',
        borderRadius: '4px',
        '& .MuiChip-label': {
          padding: '4px'
        },
        ...props.sx
      }}
    />
  );
});

StatusChip.displayName = 'StatusChip';

export default StatusChip;
